import styled, { keyframes } from "styled-components";

const fadeInScale = keyframes`
  0% {
    opacity: 0;
    transform: scale(0);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

export const ModalContainer = styled.div`
    position: fixed;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    background-color: #00000087;
    z-index: 99999999999999999999999;

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;

    animation: 0.2s ${fadeIn} forwards;

    .contentModalCustom {
        background-color: white;
        padding: 16px;
        border-radius: 4px;
        max-height: 80vh;
        overflow-y: auto;
        min-width: 300px;
        max-width: 90vw;
        cursor: auto;

        .list {

        }

        .title {
          color: #333;
          font-weight: 600;
          font-size: 18px;
          margin-bottom: 12px;  
        }
    }

    .isMinWidth > div {
      min-width: 500px;
    }

    > div {
      padding: 0;
      margin: 0;
      display: flex;
      position: relative;
      cursor: auto;

      animation: 0.2s ${fadeInScale} forwards;

      > div {
        max-height: 100vh;
        overflow: auto;
      }
    }

    .close {
      position: absolute;
      top: -30px;
      right: 0;
      cursor: pointer;
    }

    @media screen and (max-width: 800px){
      
      .close {
        font-size: 28px;
        position: initial;
        width: 100%;
        text-align: right;
      }
      
      > div {
        /* height: 90vh; */
        display: flex;
        flex-direction: column;
        
      }
    }
`